"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SurveySearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return SurveySearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../../base");
const SurveySearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("survey"),
    name_re: _zod.z.string().optional(),
    status_eq: _models.SurveyModel.shape.status.optional(),
    created_user_id_eq: _utilsisomorphic.transformObjectId.optional(),
    created_user_id_in: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    start_date_gte: _utilsisomorphic.transformDate.optional(),
    start_date_lte: _utilsisomorphic.transformDate.optional(),
    end_date_gte: _utilsisomorphic.transformDate.optional(),
    end_date_lte: _utilsisomorphic.transformDate.optional(),
    status_in: (0, _utilsisomorphic.transformStringToArray)(_models.SurveyDisplayStatusSchema).optional()
});
